import BehaviorConfig from '@/models/app-config/behavior/behavior'

import { Fku } from './model/item'

export interface SizeSelectionDisplayPolicy {
  shouldShow(fkuList: Fku[]): boolean
}

/**
 * 全てのFKUが単一のSKUしか持たないときは、サイズを選択する余地がないのでサイズ選択のUIを表示しない
 */
export class HideWhenAllFkuHaveSingleSkuPolicy implements SizeSelectionDisplayPolicy {
  shouldShow(fkuList: Fku[]): boolean {
    return !fkuList.every(fku => fku.skuList.length === 1)
  }
}

/**
 * サイズを選択する余地がなくても常にサイズ選択のUIを表示する
 */
export class AlwaysShowPolicy implements SizeSelectionDisplayPolicy {
  shouldShow(): boolean {
    return true
  }
}

export function createSizeSelectionDisplayPolicy(behavior: BehaviorConfig): SizeSelectionDisplayPolicy {
  /**
   * MCでは、売り切れたSKUを非公開にする運用により複数サイズ展開の商品が一時的に単一サイズになることがあり、
   * そのときにサイズ表記が見えないと何のサイズを買うのか分かりにくいため、常にサイズ選択を表示する
   */
  if (behavior.isMyColor) {
    return new AlwaysShowPolicy()
  }

  return new HideWhenAllFkuHaveSingleSkuPolicy()
}
